// lib/whatsappOrder.js — Commande En Un Clic via WhatsApp (deep-link wa.me).
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL || "";

export async function openWhatsAppOrder({ merchantId, merchantSlug, productId, productName, priceFcfa, qty = 1 }) {
  // Pré-ouverture au clic (anti popup-blocker) : la fenêtre est redirigée après le fetch.
  const win = window.open("about:blank", "_blank");
  try {
    const userId = (() => { try { return localStorage.getItem("jsonfirst_civ_userid"); } catch { return null; } })();
    const r = await fetch(`${API}/api/v3/whatsapp/order-link`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        merchant_id: merchantId || null,
        merchant_slug: merchantSlug || null,
        product_id: productId || null,
        product_name: productName || null,
        price_fcfa: priceFcfa || null,
        qty,
        userId,
      }),
    });
    const d = await r.json();
    if (!r.ok || !d.ok) {
      if (win) win.close();
      toast.error(d.error === "no_whatsapp"
        ? "Ce commerçant n'a pas de numéro WhatsApp enregistré."
        : "Impossible de préparer la commande WhatsApp.");
      return false;
    }
    if (win) win.location.href = d.wa_url;
    else window.open(d.wa_url, "_blank", "noopener");
    toast.success(`Commande ${d.ref} prête — envoyez le message sur WhatsApp ✓`);
    return true;
  } catch {
    if (win) win.close();
    toast.error("Connexion impossible — réessayez.");
    return false;
  }
}
